import styled from 'styled-components'

const FormWrapper = styled.div`
  padding: 15px;
  border-top: 1px solid var(--light-gray);
  height: 120px;

  textarea {
    border-color: var(--light-gray);
    resize: none;
    width: 100%;
    border-radius: 5px;
    height: 100%;
    padding: 10px;

    &::placeholder {
      color: #8d8d8d;
    }

    &:focus {
      outline: none;
    }
  }
`

const CommentForm = ({ handleChange }) => (
  <FormWrapper>
    <textarea onChange={handleChange} placeholder="Leave a comment" autoFocus />
  </FormWrapper>
)

export default CommentForm
